import { couponFormService } from '../services';

export const updateCoupon = async (cupounId: number, data: AnyObject) => {
  return await couponFormService.updateCoupon(cupounId, data);
};
